// extracted by mini-css-extract-plugin
export var sideNavWrapperStyle = "rsc_hb_side_nav-module--sideNavWrapperStyle--hZJt+";